/**
 * NetworkERC3643 — `/network/erc-3643` route.
 *
 * Body is the hand-built design from `network-erc-3643.html`. Navbar +
 * Footer + App.js routing all unchanged.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { NetworkERC3643Hero } from "../components/NetworkERC3643Hero";

export default function NetworkERC3643() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="network-erc-3643-page">
      <Helmet>
        <title>ERC-3643 : The institutional reference standard for tokenized assets.</title>
      </Helmet>
      <Navbar />
      <div aria-hidden="true" style={{ height: 64 }} />
      <NetworkERC3643Hero />
      <Footer />
    </main>
  );
}
